import { render, staticRenderFns } from "./Extractor.vue?vue&type=template&id=fa43ae2c&scoped=true"
import script from "./Extractor.vue?vue&type=script&lang=ts"
export * from "./Extractor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa43ae2c",
  null
  
)

export default component.exports